import React from "react";
import styled from "styled-components";
import SkeletonLoader from "./SkeletonLoader";

const HeaderPoints = ({ points = 0, label = "Puntos", loader = false }) => {
  const safePoints = Number.isFinite(Number(points)) ? Number(points) : 0;
  return (
    <PointsBlock>
      <SkeletonLoader active={loader} width="40px" height="10px">
        <PointsLabel>{label}</PointsLabel>
      </SkeletonLoader>
      <SkeletonLoader active={loader} width="60px" height="22px">
        <PointsValue>{safePoints}</PointsValue>
      </SkeletonLoader>
    </PointsBlock>
  );
};

export default HeaderPoints;

const PointsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  color: #fff;
`;

const PointsLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  opacity: 0.85;
`;

const PointsValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
`;
